import './ErrorFormControl.scss';

interface IErrorFormControl {
  error: string
}

const ErrorFormControl = ({ error }: IErrorFormControl) => {
  if (!error) return null;

  return (
    <div className="error-form-control" role="alert">{error}</div>
  );
};

export default ErrorFormControl;
